export default class UsageTracker {
  static track(evt, evtData, options = {}, tracker, trackerSendImmediate) {
    const {
      sendImmediate = false
    } = options;
    const trackerToUse = sendImmediate ? trackerSendImmediate : tracker;
    trackerToUse.track(evt, evtData);
  }
}